import styled from "styled-components"

export const MapSection = styled.div`
  width: 100%;
  height: var(--content-body-height);
  position: relative;
  /* border: 1px solid red; */
  /* @media screen and (min-width: 780px) {
    height: calc(100vh - 300px);
    width: 100%;
  } */
`

export const ListViewed = styled.div`
  top: 60px;
  right: 40px;
  @media screen and (max-width: 1367px) {
    top: 30px;
  }

  @media screen and (max-width: 1021px) {
    right: 24px;
  }

  @media screen and (max-width: 767px) {
    right: 16px;
  }
`

export const Cards = styled.div`
  width: ${({ open }) => (open ? "960px" : "0px")};
  right: ${({ open }) => (open ? "0px" : "-105px")};
  height: calc(100vh - 160px);
  transition: all ease-in-out 0.3s;
  overflow-y: auto;
  background: var(--navbar-background);

  @media screen and (max-width: 1021px) {
    width: ${({ open }) => (open ? "100%" : "0px")};
  }
`

export const FilterButton = styled.div`
  @media screen and (max-width: 1367px) {
    top: 30px;
  }
`
export const FilterBlock = styled.div`
  width: ${({ openFilter }) => (openFilter ? "398px" : "0px")};
  left: ${({ openFilter }) => (openFilter ? "0px" : "-165px")};
  height: 450px; // 572px
  transition: all ease-in-out 0.3s;
  border-radius: 0px 20px 20px 0px;
  background: var(--navbar-background);

  @media screen and (max-width: 1367px) {
    height: 100%;
  }
  @media screen and (max-width: 768px) {
    top: var(--navbar-height);
    width: ${({ openFilter }) => (openFilter ? "100%" : "0px")};
    height: 100%;
    border-radius: 0px;
  }

  & .filter-header {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    color: #595f62;
  }
  & .filter-body {
    max-height: calc(672px - 65px);
    height: -webkit-fill-available;
    overflow-y: auto;
    @media screen and (max-width: 1367px) {
      height: 100%;
    }
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 100%;
    }
  }
`

// export const Footer = styled.div`
//   background: rgba(45, 45, 45, 0.9);
//   backdrop-filter: blur(4px);

//   & .footer-text {
//     max-width: 262px;
//     font-family: "Lato";
//     font-style: normal;
//     font-weight: 500;
//     font-size: 14px;
//     line-height: 130%;
//     color: #c0c0c0;
//   }
// `

export const ZoomButton = styled.div`
  & button {
    width: 40px;
    height: 40px;
    background: #ffffff;
    box-shadow: 0px 3px 12px rgba(27, 58, 104, 0.33);
    border-radius: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1d395a;
  }
`
export const StepperBlock = styled.div`
  transition: all ease-in-out 0.3s;
  top: ${({ open }) => (open ? "60px" : "-200px")};

  & .stepper-box {
    width: 1071px;
    padding: 22px 0px;
    @media screen and (max-width: 1367px) {
      width: 700px;
      margin-left: 170px;
    }
  }
`
